import s from './Loader.module.scss';

const Loader = () => (
  <div className={s.loader}><div /><div /><div /><div /><div /><div /><div /><div /></div>
);

export default Loader;
